function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#share_svg__clip0_12306_38873)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.902 0a3.203 3.203 0 00-3.2 3.149V3.2c0 1.18.64 2.205 1.59 2.758a3.202 3.202 0 001.61.442 3.201 3.201 0 000-6.4zm-3.82 3.469L5.81 5.107c.761.66 1.26 1.61 1.318 2.682l3.309-1.661a3.833 3.833 0 01-1.36-2.66h.003zM3.301 4.8a3.201 3.201 0 000 6.4 3.15 3.15 0 001.77-.54A3.198 3.198 0 006.502 8c0-1.11-.611-2.154-1.52-2.72a3.168 3.168 0 00-1.68-.48zm3.83 3.411a3.845 3.845 0 01-1.308 2.691l3.26 1.63a3.823 3.823 0 011.35-2.66l-3.298-1.66h-.004zm5.77 1.389c-.66 0-1.27.205-1.78.55a3.189 3.189 0 00-1.42 2.65v.01s-.026.01-.038.01l.038.018a3.206 3.206 0 003.2 3.162c1.75 0 3.2-1.434 3.2-3.2 0-1.766-1.434-3.2-3.2-3.2z",
  fill: "#000"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "share_svg__clip0_12306_38873"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(.102)",
  d: "M0 0h16v16H0z"
})));

function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 16",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgShare;